import { useEffect } from 'react';

export const useScrollLock = (
  shouldLockScrolling = true
): { onEnableLock: () => void; onDisableLock: () => void } => {
  useEffect(() => {
    function setScrollProp() {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    }
    if (shouldLockScrolling) {
      window.addEventListener('scroll', setScrollProp);
    }

    return () => {
      if (shouldLockScrolling) {
        window.removeEventListener('scroll', setScrollProp);
      }
    };
  }, [shouldLockScrolling]);

  const onEnableLock = () => {
    if (shouldLockScrolling) {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');

      const { body } = document;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
      body.classList.add('zui-scroll-lock');
    }
  };

  const onDisableLock = () => {
    if (shouldLockScrolling) {
      const { body } = document;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      body.classList.remove('zui-scroll-lock');
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }
  };

  return { onEnableLock, onDisableLock };
};
